import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.jsx'
import './styles/globals.css'

// Remove loading screen
setTimeout(() => {
  const loadingElement = document.getElementById('root-loading');
  if (loadingElement) {
    loadingElement.style.display = 'none';
  }
}, 1000);

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)